<script setup lang="tsx">
import type { RiskOverviewChange } from '@/models/api-generated'
import CardRow from './CardRow.vue'
import { formatDate, getTreatmentText } from '@/services/utils'
import { RIC_Added, RIC_TreatmentChanged } from '@/models/enums-generated'
import { truncate } from '@/services/utils'

const model = defineModel<RiskOverviewChange[]>({ required: true })

const emit = defineEmits<{
	(e: 'go-to-risks', riskNames: string[], treatments: string[]): void
}>()

function goToRisks(name: string) {
	if (!name) return
	emit('go-to-risks', [name], [])
}
</script>

<template>
	<div class="rounded-container p-4 overflow-auto text-nowrap">
		<p class="text-center fw-bold">
			{{ $t('risk.overview.importantChanges') }}
		</p>

		<table class="w-100">
			<CardRow v-for="a in model" :underline="true" :key="a.risk.name">
				<template #col0>
					<span class="badge bg-primary me-2 fixed-badge" v-one-tooltip="a.risk.asset.name ? a.risk.asset.name : $t('risk.default')">
						{{ a.risk.asset.id > 0 ? a.risk.asset.name : $t('risk.default') }}
					</span>
					<span v-one-tooltip="a.risk.name" @click="goToRisks(a.risk.name)" class="risks-cell">{{ truncate(a.risk.name, 10) }}</span>
				</template>
				<template #col1>
					<template v-if="a.type === RIC_Added">
						{{ $t('misc.created') }}
					</template>
					<template v-else-if="a.type === RIC_TreatmentChanged">
						{{ $t('risk.riskTreatment') }}
					</template>
				</template>
				<template #col2>
					<template v-if="a.type === RIC_TreatmentChanged">
						{{ getTreatmentText(a.before) }}
						->
						{{ getTreatmentText(a.after) }}
					</template>
				</template>
				<template #col_end>{{ formatDate(a.timestamp) }}</template>
			</CardRow>
		</table>
	</div>
</template>
